import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Button, CircularProgress, Grid, IconButton, makeStyles, Paper, Tooltip } from "@material-ui/core";
import { CustomTextField } from "@totalsoft/rocket-webapp-components-deprecated";
import { useTranslation } from "react-i18next";
import { Autorenew, Search } from "@material-ui/icons";
import { get, set } from "@totalsoft/change-tracking-react";
import { onTextBoxChange } from "utils/propertyChangeAdapters";
import clientPageStyle from "features/client/styles";
import { emptyString } from "constants/defaultValues";

const useStyles = makeStyles(clientPageStyle);

function IndividualFilters({ filterLens, onReset, onSearch, loading }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleSearch = useCallback(() => onSearch(false), [onSearch]);

  const handleKeypress = useCallback(
    (e) => {
      if (e.keyCode === 13) {
        handleSearch();
      }
    },
    [handleSearch]
  );

  return (
    <Paper className={classes.filterStyle} onKeyUp={handleKeypress}>
      <Grid container spacing={2} justifyContent="space-between" alignItems="center">
        <Grid item xs={12} sm>
          <CustomTextField
            fullWidth
            label={t("Client.PIN")}
            value={(filterLens.pin |> get) || emptyString}
            onChange={filterLens.pin |> set |> onTextBoxChange}
          />
        </Grid>
        <Grid item xs={12} sm="auto">
          <IconButton color="default" onClick={onReset} style={{ marginRight: 10 }}>
            <Tooltip title={t("General.ResetFilter")}>
              <Autorenew fontSize="small" />
            </Tooltip>
          </IconButton>
          <Button
            id="clientSearch_SearchBtn"
            right="true"
            variant="contained"
            color="primary"
            onClick={handleSearch}
            endIcon={loading ? <CircularProgress size={20} color={"inherit"} /> : <Search />}
          >
            {t("General.Search")}
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
}

IndividualFilters.propTypes = {
  filterLens: PropTypes.object.isRequired,
  onReset: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default IndividualFilters;
